import React, { useEffect } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchInvestigationMaster } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { useSelector } from "react-redux";

const InvestigationFilterDropDown = ({ setFilterValue }) => {
  const key = "investigation_id";
  const login = useSelector((state) => state.jwtAuthreducer);
  const { data, isLoading, refetch, error } = useQuery(
    ["investigation-dropdown"],
    () => fetchInvestigationMaster({ payload: { ...login } }),
    {
      keepPreviousData: false,
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  useEffect(() => {
    refetch()
  }, [login])

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading investigation data</div>;

  const options =
    data?.data?.data?.map((item) => ({
      value: item.id,
      label: item.investigation_name,
    })) || [];

  return (
    <Select
      options={options}
      isClearable
      placeholder="Select Investigation"
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      onChange={(selectedOption) => {
        const value = selectedOption ? selectedOption.value : "";
        setFilterValue(key, value || "");
      }}
      className="react-select-container"
    />
  );
};

export default InvestigationFilterDropDown;
